import { AfterViewInit, Component} from '@angular/core';

@Component({
    selector: '[app-service-list]',
    templateUrl: './service-list.component.html',
    styleUrls: ['./service-list.component.css'],
    standalone: false
})
export class ServiceTasksListComponent implements AfterViewInit
{
  ngAfterViewInit()
  {
      window.dispatchEvent(new CustomEvent("ComponentLoad", { detail: "PlannedTasksList" }));
  }
}
